import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';
import { cH } from '@fullcalendar/core/internal-common';
import { forkJoin } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { TaskDepartment, TaskPriority, TaskResponsiblePerson } from 'src/app/shared/models/shared.model';
import { GlobalServices } from 'src/app/shared/services/global.services';
import { RestfullServices } from 'src/app/shared/services/restfull.services';

@Component({
  selector: 'app-task-manager-create',
  templateUrl: './task-manager-create.component.html',
  styleUrls: ['./task-manager-create.component.scss']
})
export class TaskManagerCreateComponent implements OnInit {
  files: File[] = [];
  uploadFiles: File[] = [];
  previews: string[] = [];
  isDragging = false;
  taskTeams: any;

  taskId: number;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  addEventForm: UntypedFormGroup;
  public isEdit: boolean = false;
  header: string;
  isDirty = false;
  isEscalate = false;
  tmProHotelId: number;
  uploadResults: any;
  public minDate: Date = new Date(
    new Date().setDate(new Date().getDate() + 1)
  );
  originalImages = [];
  currentImages = [];
  taskOwner: string;
  teamId: any;
  public escalationReasonList: string[] = ["Emergency situation", "Maintenance issue", "Security issue", "Staff shortage", "Urgent", "Other"]
  public responsiblePersons: any = [];//[{ name: "Peter Patrick", value: 1 }, { name: "Linsen Maria", value: 2 }]
  public priorityList: TaskPriority[]; //[{ name: "Low", value: 1 }, { name: "Medium", value: 2 }, { name: "High", value: 3 }, { name: "Important", value: 4 }]
  public taskDepartments: TaskDepartment[];// [{ name: "Maintenance & Engineering", value: 1 }, { name: "Spa Service", value: 2 }, { name: "Bar & Restaurants", value: 3 }]
  constructor(public dialogRef: MatDialogRef<TaskManagerCreateComponent>, public restfullServices: RestfullServices, private activatedRoute: ActivatedRoute, @Inject(MAT_DIALOG_DATA) public data: any, public globalService: GlobalServices, private dialog: MatDialog) { }

  ngOnInit(): void {
    //this.isEdit = this.activatedRoute.snapshot.queryParams.edit;
    this.tmProHotelId = +localStorage.getItem('selectedTmProHotelId');
    this.header = this.data.eventType == "isEdit" ? "EDIT" : "CREATE";
    this.addEventForm = new UntypedFormGroup({
      department: new UntypedFormControl(""),
      responsiblePerson: new UntypedFormControl(""),
      priority: new UntypedFormControl("", Validators.required),
      dueDate: new UntypedFormControl("", Validators.required),
      title: new UntypedFormControl("", Validators.required),
      description: new UntypedFormControl("", Validators.required),
      location: new UntypedFormControl("", Validators.required),
      photo: new UntypedFormControl(""),
      isEscalate: new UntypedFormControl(""),
      escalationReason: new UntypedFormControl(""),
      remarks: new UntypedFormControl(""),
    });
    if (this.data.eventType === "isEdit" && this.data.formData) {
      this.taskId = this.data.taskId;
      this.addEventForm.patchValue(this.data.formData);

      // Handle escalation toggle
      this.isEscalate = !!this.data.formData.isEscalate;
      this.addEventForm.controls['isEscalate'].setValue(this.isEscalate);

      // Optional: ensure other fields are filled when editing
      this.addEventForm.patchValue({
        //escalationReason: this.data.formData.escalationReason != null || this.data.formData.escalationReason != "" ? "" : this.data.formData.escalationReason,
        //remarks: this.data.formData.remarks
      });
      this.getTaskImages();
      this.addEventForm.valueChanges.subscribe(() => {
        this.isDirty = true;
      });
    }
    this.getTaskOwner();
    this.initializeDropdowns();
    //Initialize dropdowns
  }
  getTaskOwner() {
    this.restfullServices.getTeamMemberByHotelId().subscribe({
      next: async (response) => {
        this.teamId = response.tmProTeamId;
        this.taskOwner = response.userId;
      }, error: (err) => {
        console.error('Error saving task:', err);
        this.globalService.showLoader$.next(false);
      }
    });
  }
  getTaskImages() {
    this.globalService.showLoader$.next(true);
    this.restfullServices.getImage(+this.tmProHotelId, +this.taskId).subscribe({
      next: (res) => {
        this.uploadResults = res;
        this.originalImages = res;
        this.currentImages = JSON.parse(JSON.stringify(res));
        this.uploadResults.forEach(element => {
          this.previews.push(element.base64);
        });
        this.globalService.showLoader$.next(false);
      },
      error: (err) => {
        console.error(err);
        this.globalService.showLoader$.next(false);
      }
    });
  }
  getDeletedImages() {
    return this.originalImages.filter(orig =>
      !this.currentImages.some(curr => curr.id === orig.id)
    );
  }
  initializeDropdowns() {
    this.restfullServices.getTaskPriority().subscribe((response) => {
      // var priority = response.map((element)=>element.text.upper)
      this.priorityList = response;
      this.priorityList.pop();
    })
    this.restfullServices.getTaskDepartments(this.tmProHotelId).subscribe((response) => {
      this.taskDepartments = response;
    })
    this.restfullServices.getTaskAllResponsiblePerson().subscribe((response) => {
      this.responsiblePersons = response;
    })
  }
  departmentChange(deptId: any) {
    this.isDirty = true;
    this.restfullServices.getTeamsByDepartmentId(deptId).subscribe((response) => {
      this.taskTeams = response;
      if (response) {
        this.processAllDepartments();
      }
    })
  }
  processAllDepartments() {
    forkJoin(this.taskTeams.map(dep => this.restfullServices.getTaskResponsiblePerson(dep.id)))
      .subscribe(results => {
        this.responsiblePersons = results[0];
      });

  }
  combinedDisplayName(firstName: string, lastName: string) {
    return firstName.charAt(0).toLocaleUpperCase() + firstName.slice(1) + " " + lastName.charAt(0).toUpperCase() + lastName.slice(1);
  }

  priorityChange(event: Event) {
    this.isDirty = true;
  }
  responsiblePersonChange(event: Event) {
    this.isDirty = true;
  }

  //Image upload section
  // Drag and drop handlers
  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
    if (event.dataTransfer?.files) {
      this.addFiles(event.dataTransfer.files);
    }
  }

  // File input selection
  onFilesSelected(event: any) {
    this.isDirty = true;
    const files: FileList = event.target.files;
    this.addFiles(files);
  }

  // Helper to add files and generate previews
  private addFiles(fileList: FileList) {
    this.isDirty = true;
    Array.from(fileList).forEach(file => {
      if (file.type.startsWith('image/')) {
        this.files.push(file);
        this.uploadFiles.push(file);

        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.previews.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    });
  }

  // Remove image
  removeImage(index: number) {
    this.isDirty = true;
    // newly uploaded images
    //this.files.splice(index, 1);
    // CASE A — image exists in server
    if (this.currentImages[index]?.id) {
      this.currentImages.splice(index, 1);
    }
    // CASE B — image is new (not yet uploaded)
    else {
      this.uploadFiles.splice(index - this.currentImages.length, 1);
    }

    this.previews.splice(index, 1);
  }

  // Fetch uploaded files (for API upload)
  getSelectedFiles(): File[] {
    return this.files;
  }
  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }
  onBrowseClick(event: Event) {
    event.stopPropagation(); //prevents twice open of browse files
  }

  // Convert all selected files to the API request format
  async prepareUploadPayload(taskID: number): Promise<any[]> {
    const payload = await Promise.all(
      this.uploadFiles.map(async (file, index) => {
        const base64 = await this.convertToBase64(file);
        return {
          tmProTaskId: taskID,
          filename: file.name,
          displayname: file.name,
          path: "tasks",
          comment: "",
          base64: base64
        };
      })
    );

    return payload;
  }

  // Utility: convert File → Base64
  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);  // outputs: data:image/png;base64,XXXXX
      reader.onload = () => {
        const result = reader.result as string;
        // If your backend expects *just* the raw base64 string without "data:image/png;base64,"
        // you can strip it:
        const base64 = result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = error => reject(error);
    });
  }


  async onSubmit() {
    if (this.data.eventType == "isEdit") {
      //Check if escalated
      // If escalate selected, confirm first
      if (this.addEventForm.controls['isEscalate'].value === true && !!this.data.formData.isEscalate == false) {
        const confirmed = await this.confirmEscalation();

        if (!confirmed) {
          this.isEscalate = false;
          this.addEventForm.controls['isEscalate'].setValue(false);
          const reasonControl = this.addEventForm.get('escalationReason');
          reasonControl?.clearValidators();
          reasonControl?.updateValueAndValidity();
          return;
        } else {
          this.isEscalate = true;
        }
      }
      if (!this.addEventForm.invalid) {
        this.globalService.showLoader$.next(true);
        console.log(this.data.formData.created);
        //Prapare payload
        let payload = {
          id: this.taskId,
          hotelId: this.tmProHotelId,
          tmProStatusId: this.data.tmProStatusId,
          categoryId: 5,
          tmProDepartmentId: this.addEventForm.controls["department"].value,
          tmProTeamId: this.teamId,
          created: this.data.created,
          closed: this.addEventForm.controls["dueDate"].value.toISOString(),
          taskOwner: this.taskOwner,//"61bcc4e5-3f87-4d89-885b-5e49fdeed477",
          isInternal: true,
          taskName: this.addEventForm.controls["title"].value,
          description: this.addEventForm.controls["description"].value,
          shortDescription: "",
          responsiblePerson: this.addEventForm.controls["responsiblePerson"].value,
          toBeDoneBy: this.addEventForm.controls["dueDate"].value.toISOString(),
          tmProPriorityId: this.addEventForm.controls["priority"].value,
          tags: "",
          location: this.addEventForm.controls["location"].value,
          isEscalate: this.isEscalate,
          escalationReason: this.addEventForm.controls['escalationReason'].value,
          remarks: this.addEventForm.controls['remarks'].value
        }
        //Call save task api
        this.restfullServices.updateTask(payload).subscribe({
          next: async (response) => {
            if (response) {
              // --------------------------------------
              // DELETE removed old images before upload
              // --------------------------------------
              const deletedImages = this.getDeletedImages();
              if (deletedImages.length > 0) {
                const deleteCalls = deletedImages.map(img =>
                  this.restfullServices.deleteTaskPicture(img.id).toPromise()
                );

                await Promise.all(deleteCalls);
                console.log("Deleted removed images:", deletedImages);
              }
              const payloadPicture = await this.prepareUploadPayload(response.id);

              const uploadPromises = this.uploadFiles.map((element) => {
                let payl = {
                  id: this.tmProHotelId,
                  taskId: response.id,
                  path: "tasks",
                  file: element
                }
                return this.restfullServices.uploadSingle(payl).toPromise()
              }
              );
              const uploadResponses = await Promise.all(uploadPromises);

              console.log('All uploads completed:', uploadResponses);
              if (uploadResponses.length !== 0) {

                const saveImageCalls = uploadResponses.map((res, index) => {

                  // FIXED: response is an array → take first element
                  payloadPicture[index].filename = res[0].storedFileName;

                  return this.restfullServices
                    .saveTaskImages(payloadPicture[index])
                    .toPromise();
                });

                await Promise.all(saveImageCalls);

                this.globalService.showLoader$.next(false);
                this.dialogRef.close({ status: 'editSuccess', taskId: response.id });
              }
              else {
                this.globalService.showLoader$.next(false);
                this.dialogRef.close({ status: 'editSuccess', taskId: response.id });
              }
            }
          },
          error: (err) => {
            console.error('Error saving task:', err);
            this.globalService.showLoader$.next(false);
          }
        });
      }
      else {
        this.addEventForm?.markAllAsTouched();
        return;
      }
    }
    else {
      //Check if escalated
      // If escalate selected, confirm first
      if (this.addEventForm.controls['isEscalate'].value === true) {
        const confirmed = await this.confirmEscalation();

        if (!confirmed) {
          this.isEscalate = false;
          this.addEventForm.controls['isEscalate'].setValue(false);
          const reasonControl = this.addEventForm.get('escalationReason');
          reasonControl?.clearValidators();
          reasonControl?.updateValueAndValidity();
          return;
        } else {
          this.isEscalate = true;
        }
      }
      if (!this.addEventForm.invalid) {
        this.globalService.showLoader$.next(true);

        let payload = {
          id: 0,
          hotelId: this.tmProHotelId,
          tmProStatusId: 1,
          categoryId: 5,
          tmProDepartmentId: this.addEventForm.controls["department"].value == "" || this.addEventForm.controls["department"].value == undefined ? 19 : this.addEventForm.controls["department"].value,
          tmProTeamId: this.teamId,
          created: new Date(),
          closed: this.addEventForm.controls["dueDate"]?.value.toISOString(),
          taskOwner: this.taskOwner,//"61bcc4e5-3f87-4d89-885b-5e49fdeed477",
          isInternal: true,
          taskName: this.addEventForm.controls["title"].value,
          description: this.addEventForm.controls["description"].value,
          shortDescription: "",
          responsiblePerson: this.addEventForm.controls["responsiblePerson"].value,
          toBeDoneBy: this.addEventForm.controls["dueDate"].value.toISOString(),
          tmProPriorityId: this.addEventForm.controls["priority"].value,
          tags: "",
          location: this.addEventForm.controls["location"].value,
          isEscalate: this.isEscalate,
          escalationReason: this.addEventForm.controls['escalationReason'].value,
          remarks: this.addEventForm.controls['remarks'].value
        }
        this.restfullServices.saveTask(payload).subscribe({
          next: async (response) => {
            if (response) {
              const payloadPicture = await this.prepareUploadPayload(response.id);
              const uploadPromises = this.uploadFiles.map((element) => {
                let payl = {
                  id: this.tmProHotelId,
                  taskId: response.id,
                  path: "tasks",
                  file: element
                }
                return this.restfullServices.uploadSingle(payl).toPromise()
              }
              );
              const uploadResponses = await Promise.all(uploadPromises);

              console.log('All uploads completed:', uploadResponses);
              if (uploadResponses.length !== 0) {

                const calls = uploadResponses.map((res, index) => {
                  payloadPicture[index].filename = res[0].storedFileName;
                  return this.restfullServices.saveTaskImages(payloadPicture[index]);
                });

                forkJoin(calls).subscribe({
                  next: () => {
                    this.globalService.showLoader$.next(false);
                    this.dialogRef.close({ status: 'success', taskId: response.id });
                  },
                  error: (err) => {
                    console.error(err);
                    this.globalService.showLoader$.next(false);
                  }
                });
              }
              else {
                this.globalService.showLoader$.next(false);
                this.dialogRef.close({ status: 'success', taskId: response.id });
              }
            }
          },
          error: (err) => {
            console.error('Error saving task:', err);
            this.globalService.showLoader$.next(false);
          }
        });
      }
      else {
        this.addEventForm?.markAllAsTouched();
        return;
      }
    }
  }
  private async confirmEscalation(): Promise<boolean> {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      panelClass: "custom_dialog_container",
      width: "440px",
      data: {
        title: "Escalate Task",
        message: `Are you sure you want to escalate this task? Once escalated, it cannot be undone.`,
        buttonText: "Confirm",
        type: "confirmDeny",
      },
    });

    const result = await dialogRef.afterClosed().pipe(take(1)).toPromise();
    return !!result; // true if confirmed
  }
  onCancel() {
    if (this.isDirty == true) {
      this.confirmUnsaved();
    } else {
      this.dialogRef.close({ status: 'cancel' });
    }
  }
  confirmUnsaved() {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      panelClass: "custom_dialog_container",
      width: "440px",
      data: {
        title: "Unsaved Changes",
        message: `Are you sure you want to leave this page? Unsaved changes will be lost!`,
        type: "confirmUnsavedChangesCustom",
      },
    });

    // When confirmation dialog closes:
    dialogRef.afterClosed()
      .pipe(filter(result => !!result)) // only if user clicked "Yes" or confirmed
      .subscribe(() => {
        // Close both dialogs now
        this.dialogRef.close({ status: 'cancel' });
      });
  }
  convertToIso(dateStr: string): string {
    const [month, day, year] = dateStr.split('/').map(Number);
    const now = new Date();
    const dateObj = new Date(year, month - 1, day, now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
    return dateObj.toISOString();
  }
  onEscalateChange(event: any) {
    //already escalated once, so show prompt
    if (this.data.eventType == "isEdit" && !!this.data.formData.isEscalate == true) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        panelClass: "custom_dialog_container",
        width: "440px",
        data: {
          title: "Action Not Allowed",
          message: `This task has already been escalated and no longer be unmarked.`,
          type: "message",
        },
      });
      this.addEventForm.controls['isEscalate'].setValue(true);
    }
    else {
      const checked = event.checked;
      this.addEventForm.controls['isEscalate'].setValue(checked);

      const reasonControl = this.addEventForm.get('escalationReason');

      if (checked === true) {
        this.isEscalate = true;
        reasonControl?.setValidators([Validators.required]);
      } else {
        reasonControl?.clearValidators();
        this.isEscalate = false;
      }

      reasonControl?.updateValueAndValidity();
    }
  }
  escalationReasonChange(event: any) {
    this.addEventForm.controls['escalationReason'].setValue(event.value);
  }
}
